"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookSpec = exports.Spec = exports.UnknownOwner = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Metadata = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Metadata.Spec';
const Role = User.GlobalUserRole.enums;
const withReadGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandSupportOperator, Role.BrandTechOperator, Role.Dealer, Role.DealerTechnician);
const withWriteGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager);
const withTechnicalGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandTechOperator, Role.Dealer);
const ItemsResponse = openapi_1.Response.Success(Metadata.Items).annotations({
    description: 'Stored metadata',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful metadata mutation',
});
/*
 * changeUser and changeDevice return false when the owner does not exist, and
 * the controller answers with the bare code. The user-app path cannot reach
 * this: a missing configuration still answers 200.
 */
exports.UnknownOwner = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.UnknownOwner`, 'INVALID_REQUEST', 'Unknown Owner', 'The user or device does not exist. Carries no express-validator field errors.');
const getUserMetadata = platform_1.HttpApiEndpoint.get('getUserMetadata') `/user`
    .setUrlParams(Metadata.UserQuery)
    .addSuccess(ItemsResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get User Metadata')
    .annotate(platform_1.OpenApi.Description, 'Returns shared metadata for a user (available to every client app the user is logged into). Missing users currently return 200 with items {}.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const addUserMetadata = platform_1.HttpApiEndpoint.post('addUserMetadata') `/user`
    .setPayload(Metadata.UserUpsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Add User Metadata')
    .annotate(platform_1.OpenApi.Description, 'Merges or overwrites shared user metadata keys. ownerType is not a client field. A missing user is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const removeUserMetadata = platform_1.HttpApiEndpoint.del('removeUserMetadata') `/user`
    .setPayload(Metadata.UserRemovalPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Remove User Metadata')
    .annotate(platform_1.OpenApi.Description, 'Removes listed shared user metadata keys, or all of them when items is omitted. A missing user is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const getUserAppMetadata = platform_1.HttpApiEndpoint.get('getUserAppMetadata') `/user/app`
    .setUrlParams(Metadata.UserAppQuery)
    .addSuccess(ItemsResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get User App Metadata')
    .annotate(platform_1.OpenApi.Description, 'Returns client-application metadata for a user. Not visible to other client apps. Missing configs currently return 200 with items {}.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const addUserAppMetadata = platform_1.HttpApiEndpoint.post('addUserAppMetadata') `/user/app`
    .setPayload(Metadata.UserAppUpsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Add User App Metadata')
    .annotate(platform_1.OpenApi.Description, 'Merges or overwrites per-app user metadata keys. ownerType is not a client field. A missing configuration answers 200 and saves nothing GET can read: the document is stored without the appId-userId id, so a later GET still returns items {}.')
    .pipe(withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const removeUserAppMetadata = platform_1.HttpApiEndpoint.del('removeUserAppMetadata') `/user/app`
    .setPayload(Metadata.UserAppRemovalPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Remove User App Metadata')
    .annotate(platform_1.OpenApi.Description, 'Removes listed per-app user metadata keys, or all of them when items is omitted. Does not remove shared user metadata. A missing configuration answers 200 and saves nothing GET can read: the document is stored without the appId-userId id, so a later GET still returns items {}.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const getDeviceMetadata = platform_1.HttpApiEndpoint.get('getDeviceMetadata') `/device`
    .setUrlParams(Metadata.DeviceQuery)
    .addSuccess(ItemsResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Device Metadata')
    .annotate(platform_1.OpenApi.Description, 'Returns metadata for a device. The validator requires at least one of deviceSerialNumber and manufacturingSerialNumber, and deviceSerialNumber wins when both are set. Lookup is by id only, so a manufacturingSerialNumber-only query returns 200 with items {} even for an existing device.')
    .pipe(withReadGuard, openapi_1.Error.withV1StandardErrors);
const addDeviceMetadata = platform_1.HttpApiEndpoint.post('addDeviceMetadata') `/device`
    .setPayload(Metadata.DeviceUpsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Add Device Metadata')
    .annotate(platform_1.OpenApi.Description, 'Merges or overwrites device metadata keys. Supply at least one of deviceSerialNumber and manufacturingSerialNumber; both are accepted and deviceSerialNumber wins. A missing device is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const removeDeviceMetadata = platform_1.HttpApiEndpoint.del('removeDeviceMetadata') `/device`
    .setPayload(Metadata.DeviceRemovalPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Remove Device Metadata')
    .annotate(platform_1.OpenApi.Description, 'Removes listed device metadata keys, or all of them when items is omitted. A missing device is a second 422 shape that carries only INVALID_REQUEST.')
    .pipe(withWriteGuard, openapi_1.Error.withV1StandardErrors);
const addDeviceMetadataWebhook = platform_1.HttpApiEndpoint.post('addDeviceMetadataWebhook') `/metadata`
    .setPayload(Metadata.DeviceUpsertPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.UnknownOwner)
    .annotate(platform_1.OpenApi.Title, 'Add Device Metadata (Svix webhook)')
    .annotate(platform_1.OpenApi.Description, 'Same as POST /admin/metadata/device, then acknowledges DEVICE_INVENTORY_UPDATE_ACKNOWLEDGED. Authenticated by WebHookRouteGuard (Svix), not Bearer; that guard answers 403 NOT_ALLOWED, so the documented 401 comes from the shared Svix middleware and does not occur here.')
    .pipe(openapi_1.Security.SvixWebhook, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.metadata')
    .add(getUserMetadata)
    .add(addUserMetadata)
    .add(removeUserMetadata)
    .add(getUserAppMetadata)
    .add(addUserAppMetadata)
    .add(removeUserAppMetadata)
    .add(getDeviceMetadata)
    .add(addDeviceMetadata)
    .add(removeDeviceMetadata)
    .prefix('/admin/metadata')
    .annotate(platform_1.OpenApi.Title, 'Metadata')
    .annotate(platform_1.OpenApi.Description, 'Admin user, user-app and device metadata endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
exports.WebhookSpec = platform_1.HttpApiGroup.make('v1.webhook.svix.device.metadata')
    .add(addDeviceMetadataWebhook)
    .prefix('/webhook/svix/device')
    .annotate(platform_1.OpenApi.Title, 'Device Metadata Webhook')
    .annotate(platform_1.OpenApi.Description, 'Svix inventory-update webhook that writes device metadata')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map